export default "__VITE_ASSET__BUPtRAes__"